export default {
  state: {
    perms: [],  // 用户权限标识集合
    deptId: sessionStorage.getItem("deptId"),
    roles: sessionStorage.getItem("roles") || [],
    status: sessionStorage.getItem("status")
  },
  getters: {},
  mutations: {
    setPerms(state, perms) {  // 用户权限标识集合
      state.perms = perms;
    },
    setDeptId: function (state, deptId) {
      state.deptId = deptId;
      sessionStorage.setItem("deptId", deptId);
    },
    setRoles: function (state, roles) {
      state.roles = roles;
      sessionStorage.setItem("roles", roles);
    },
    setStatus: function (state, status) {
      state.status = status;
      sessionStorage.setItem("status", status);
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js